import React from 'react'
import clsx from 'clsx'
import styles from './LiveStats.module.scss'
import {T, useUIGlobalContext} from '@colonist/ui'

export interface LiveStatsProps {
    className?: string
}

export const LiveStats = ({
    className,
}: LiveStatsProps) => {
    const {playersOnline, gamesToday} = useUIGlobalContext()

    return (
        <div className={clsx(styles.liveStats, className)}>
            <div className={styles.stat}>
                <span className={styles.value}>{playersOnline.toLocaleString()}</span>
                <span className={styles.label}><T id='strings:liveStats.online' /></span>
            </div>
            <div className={styles.stat}>
                <span className={styles.value}>{gamesToday.toLocaleString()}</span>
                <span className={styles.label}><T id='strings:liveStats.gamesToday' options={{count: gamesToday}} /></span>
            </div>
        </div>
    )
}
